/* MUV — Subcategory grid: prev/next arrows for the horizontal scroller.
   The Filter / Sort By toolbar is intentionally LEFT in its native location
   (inside `.facets-container`, which the theme paints sticky beneath the
   header). Moving it out broke two things:
     1. The native sticky bar was emptied and visually disappeared on scroll.
     2. The `<facet-filters-form>` constructor binds the Filter button's
        onclick by querying inside itself; if we'd already detached the
        button before the constructor ran, the handler never bound and
        clicking Filter did nothing. */
(function () {
  // Cards advanced per click on the prev/next chevrons. Two feels right on
  // desktop where ~5 cards fit on screen — one feels too slow, three jumps
  // past content the user was looking at. Bump to taste.
  const STEP_CARDS = 2;

  function getStepSize(scroller) {
    const item = scroller.querySelector('.subcategory-grid__item');
    if (!item) return scroller.clientWidth;
    const itemRect = item.getBoundingClientRect();
    const track = scroller.querySelector('.subcategory-grid__track');
    const gap = track ? parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0 : 0;
    return (itemRect.width + gap) * STEP_CARDS;
  }

  function updateNavState(scroller, prevBtn, nextBtn) {
    const max = scroller.scrollWidth - scroller.clientWidth;
    const atStart = scroller.scrollLeft <= 1;
    const atEnd = scroller.scrollLeft >= max - 1;
    const overflow = max > 1;
    if (prevBtn) prevBtn.hidden = !overflow || atStart;
    if (nextBtn) nextBtn.hidden = !overflow || atEnd;
  }

  function bindArrows() {
    document.querySelectorAll('[data-subcat-scroller]').forEach((scroller) => {
      if (scroller.dataset.muvNavBound === 'true') return;
      scroller.dataset.muvNavBound = 'true';
      const wrap = scroller.closest('.subcategory-grid__scroller-wrap');
      if (!wrap) return;
      const prevBtn = wrap.querySelector('[data-subcat-prev]');
      const nextBtn = wrap.querySelector('[data-subcat-next]');

      const scrollBy = (dir) => {
        scroller.scrollBy({ left: dir * getStepSize(scroller), behavior: 'smooth' });
      };
      if (prevBtn) prevBtn.addEventListener('click', () => scrollBy(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollBy(1));

      const refresh = () => updateNavState(scroller, prevBtn, nextBtn);
      scroller.addEventListener('scroll', refresh, { passive: true });
      window.addEventListener('resize', refresh);
      scroller.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', refresh, { once: true });
      });
      refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindArrows);
  } else {
    bindArrows();
  }
  document.addEventListener('shopify:section:load', bindArrows);
  document.addEventListener('shopify:section:reorder', bindArrows);
})();
